/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-info': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10 7a1 1 0 110-2 1 1 0 010 2zm1 7a1 1 0 01-2 0V9a1 1 0 012 0v5zM10 0C4.477 0 0 4.477 0 10s4.477 10 10 10c5.522 0 10-4.477 10-10S15.522 0 10 0z" _fill="#566473"/>'
  }
})
